import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { styled } from "./styled";
export const InputFocusedContext = React.createContext(false);
export const KeyboardHintContainer = styled("div", {
    fontSize: 10,
    lineHeight: 10,
    padding: 5,
    height: 10,
    minWidth: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px #ccc solid",
    color: "#ccc",
    borderRadius: 5,
    marginRight: 5,
});
export const KeyboardHint = React.memo(function KeyboardHint(props) {
    const inputFocused = React.useContext(InputFocusedContext);
    return (_jsxs(KeyboardHintContainer, { children: [props.showTabHint === true && inputFocused ? "Tab + " : "", props.value, inputFocused && props.value === "1" && props.showTabHint === true
                ? " / Enter"
                : ""] }));
});
